export const entityLabel = (item = {}) => item.displayName || item.legalName || item.company || item.businessName || item.name || item.fullName || String(item.id || '');
export function selectedEntityIds(record = {}, kind) {
  record = record || {};
  const values = record[`${kind}Ids`];
  if (!Array.isArray(values) && Array.isArray(record.relations)) return relationEntityIds(record, { client: 'CLIENT', supplier: 'SUPPLIER', staff: 'TEAM_MEMBER' }[kind]);
  return (Array.isArray(values) ? values : record[`${kind}Id`] ? [record[`${kind}Id`]] : []).map(String);
}
export function entitySelectionPayload(record = {}) {
  record = record || {};
  return Object.fromEntries(['client', 'supplier', 'staff'].filter((kind) => Array.isArray(record[`${kind}Ids`]))
    .map((kind) => [`${kind}Ids`, record[`${kind}Ids`].map(Number)]));
}


export function relationEntityIds(record = {}, entityType) {
  const ids = (record.relations || []).filter((item) => item.entityType === entityType).map((item) => String(item.entityId));
  if (entityType === 'CLIENT' && record.clientId && !ids.includes(String(record.clientId))) ids.unshift(String(record.clientId));
  return ids;
}
export function replaceEntityRelations(relations = [], entityType, ids = [], options = []) {
  return [...relations.filter((item) => item.entityType !== entityType),
    ...ids.map((id) => ({ entityType, entityId: String(id), label: entityLabel(options.find((item) => String(item.id) === String(id))) }))];
}

export function hasSelectedEntity(record, kind, id) {
  return selectedEntityIds(record, kind).includes(String(id));
}
